import React, {forwardRef, useImperativeHandle} from 'react'
import {Grid} from "semantic-ui-react"
import DropDown from "../../../../components/commonComponents/formComponents/dropDown";
import InputField from '../../../../components/commonComponents/formComponents/inputField';

const ExportErrorMock = forwardRef((props, ref) => {
    const [errorNo, setErrorNo] = React.useState("");
    const [errorPlace1, setErrorPlace1] = React.useState("");
    const [errorPlace2, setErrorPlace2] = React.useState("");
    const [errorDesc1, setErrorDesc1] = React.useState("");
    const [errorDesc2, setErrorDesc2] = React.useState("");
    useImperativeHandle(ref, () => ({
        getErrorData: () =>  ({
            errorNo,
            errorPlace1,
            errorPlace2,
            errorDesc1,
            errorDesc2
        })
    }));
    return ( 
        <>
            <Grid.Row className="entry-number-row">
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error No"
                        value={errorNo}
                        onChange={(value) => setErrorNo(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Place 1"
                        value={errorPlace1}
                        onChange={(value) => setErrorPlace1(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Place 2"
                        value={errorPlace2}
                        onChange={(value) => setErrorPlace2(value)}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row className="entry-number-row">
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Description 1"
                        value={errorDesc1}
                        onChange={(value) => setErrorDesc1(value)}
                    />
                </Grid.Column>
                <Grid.Column computer={5}>
                    <InputField
                        isLabel={false}
                        className={'field-bg'}
                        label="Error Decription 2"
                        value={errorDesc2}
                        onChange={(value) => setErrorDesc2(value)}
                    />
                </Grid.Column>
            </Grid.Row>
        </>
     );
})
 
export default ExportErrorMock;